import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as _58 from "./applications/transfer/v1/genesis";
import * as _59 from "./applications/transfer/v1/query";
import * as _60 from "./applications/transfer/v1/transfer";
import * as _61 from "./applications/transfer/v1/tx";
import * as _62 from "./applications/transfer/v2/packet";
import * as _63 from "./core/channel/v1/channel";
import * as _64 from "./core/channel/v1/genesis";
import * as _65 from "./core/channel/v1/query";
import * as _66 from "./core/channel/v1/tx";
import * as _67 from "./core/client/v1/client";
import * as _68 from "./core/client/v1/genesis";
import * as _69 from "./core/client/v1/query";
import * as _70 from "./core/client/v1/tx";
import * as _71 from "./core/commitment/v1/commitment";
import * as _72 from "./core/connection/v1/connection";
import * as _73 from "./core/connection/v1/genesis";
import * as _74 from "./core/connection/v1/query";
import * as _75 from "./core/connection/v1/tx";
import * as _76 from "./lightclients/localhost/v1/localhost";
import * as _77 from "./lightclients/solomachine/v1/solomachine";
import * as _78 from "./lightclients/solomachine/v2/solomachine";
import * as _79 from "./lightclients/tendermint/v1/tendermint";
import * as _145 from "./applications/transfer/v1/tx.amino";
import * as _146 from "./core/channel/v1/tx.amino";
import * as _147 from "./core/client/v1/tx.amino";
import * as _148 from "./core/connection/v1/tx.amino";
import * as _149 from "./applications/transfer/v1/tx.registry";
import * as _150 from "./core/channel/v1/tx.registry";
import * as _151 from "./core/client/v1/tx.registry";
import * as _152 from "./core/connection/v1/tx.registry";
import * as _153 from "./applications/transfer/v1/query.lcd";
import * as _154 from "./core/channel/v1/query.lcd";
import * as _155 from "./core/client/v1/query.lcd";
import * as _156 from "./core/connection/v1/query.lcd";
import * as _157 from "./applications/transfer/v1/query.rpc.Query";
import * as _158 from "./core/channel/v1/query.rpc.Query";
import * as _159 from "./core/client/v1/query.rpc.Query";
import * as _160 from "./core/connection/v1/query.rpc.Query";
import * as _161 from "./applications/transfer/v1/tx.rpc.msg";
import * as _162 from "./core/channel/v1/tx.rpc.msg";
import * as _163 from "./core/client/v1/tx.rpc.msg";
import * as _164 from "./core/connection/v1/tx.rpc.msg";
import * as _185 from "./lcd";
import * as _186 from "./rpc.query";
import * as _187 from "./rpc.tx";
export let ibc;
(function (_ibc) {
  let applications;
  (function (_applications) {
    let transfer;
    (function (_transfer) {
      const v1 = _transfer.v1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _58), _59), _60), _61), _145), _149), _153), _157), _161);
      const v2 = _transfer.v2 = _objectSpread({}, _62);
    })(transfer || (transfer = _applications.transfer || (_applications.transfer = {})));
  })(applications || (applications = _ibc.applications || (_ibc.applications = {})));
  let core;
  (function (_core) {
    let channel;
    (function (_channel) {
      const v1 = _channel.v1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _63), _64), _65), _66), _146), _150), _154), _158), _162);
    })(channel || (channel = _core.channel || (_core.channel = {})));
    let client;
    (function (_client) {
      const v1 = _client.v1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _67), _68), _69), _70), _147), _151), _155), _159), _163);
    })(client || (client = _core.client || (_core.client = {})));
    let commitment;
    (function (_commitment) {
      const v1 = _commitment.v1 = _objectSpread({}, _71);
    })(commitment || (commitment = _core.commitment || (_core.commitment = {})));
    let connection;
    (function (_connection) {
      const v1 = _connection.v1 = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _72), _73), _74), _75), _148), _152), _156), _160), _164);
    })(connection || (connection = _core.connection || (_core.connection = {})));
  })(core || (core = _ibc.core || (_ibc.core = {})));
  let lightclients;
  (function (_lightclients) {
    let localhost;
    (function (_localhost) {
      const v1 = _localhost.v1 = _objectSpread({}, _76);
    })(localhost || (localhost = _lightclients.localhost || (_lightclients.localhost = {})));
    let solomachine;
    (function (_solomachine) {
      const v1 = _solomachine.v1 = _objectSpread({}, _77);
      const v2 = _solomachine.v2 = _objectSpread({}, _78);
    })(solomachine || (solomachine = _lightclients.solomachine || (_lightclients.solomachine = {})));
    let tendermint;
    (function (_tendermint) {
      const v1 = _tendermint.v1 = _objectSpread({}, _79);
    })(tendermint || (tendermint = _lightclients.tendermint || (_lightclients.tendermint = {})));
  })(lightclients || (lightclients = _ibc.lightclients || (_ibc.lightclients = {})));
  const ClientFactory = _ibc.ClientFactory = _objectSpread(_objectSpread(_objectSpread({}, _185), _186), _187);
})(ibc || (ibc = {}));